export default {
  // Режимдер
  "common.mode.auto": "Автоматтык режим (өзүндө өндөгдөн энергияны колдонуу)",
  "common.mode.economy": "Экономикалык режим",
  "common.mode.exigency": "Төзөк жағдай режимы",

  // Көчөмдөр
  "common.grid": "Электрик сеть",
  "common.evChargers": "Электрик көчөк үндөгчүлөр ( көпчүлүк)",
  "common.evCharger": "Электрик көчөк үндөгчү",
  "common.pv": "Күн энергиясы (PV)",
  "common.inverter": "Инвертор (электрик энергиясын өзгөртүү көчөмү)",
  "common.pcs": "Инвертор + Баттарея",
  "common.terminal": "Терминалдык көчөм",
  "common.airc": "Кондиционер (AC)",
  "common.engine": "Двигатель",
  "common.battery": "Баттарея",
  "common.metter": "Электрик счетчик",
  "common.other": "Башкалар",
  "common.power": "Күч",
  "common.powerTotal": "Жалпы күч",
  "common.voltage": "Төксөз",
  "common.electricity": "Электрик",
  "common.current": "Ток",
  "common.homeUsage": "Жалпы үй жүзүн",
  "common.battery.power": "Баттарея күчү",

  // Мaalыматтар
  "common.noDataAvailable": "Азырда маалымат жок~",
  "common.tips": "Илтимостуулар",
  "common.reset": "Баштап баштоо (тазалоо)",
  "common.currencyUnit": "¥ (Юань)",
  "common.submiting": "Жөнөтүүдө... Куттуунуузун үүзүнө салуу...",
  "common.close": "Жабуу",
  "common.from": "Ден",
  "common.useIn": "Учун",
  "common.energyPercent": "Энергия астырымын үздік",
  "common.dataFlow": "Мaalымат астырымы",
  "common.getDataIng": "Мaalымат алынуда... Куттуунуузун үүзүнө салуу...",
  "common.pageLoading": "Бет жүктөлүүдө... Куттуунуузун үүзүнө салуу...",
  "common.reseting": "Бет баштап башталуда... Куттуунуузун үүзүнө салуу...",
  "common.save": "Сактоо",
  "common.onlyNumberTips": "Тек сандарды киргизүүгө болот",
  "common.offline": "Офлайн (интернетке bağlı эмес)",
  "common.online": "Онлайн (интернетке bağlı)",
  "common.fault": "Ката (проблема)",
  "common.charge": "Үндөгдөш (баттареяга)",
  "common.discharge": "Чыккөш (баттареянын энергиясын колдонуу)",
  "common.buy": "Аlaq",
  "common.sell": "Сатып берүү",
  "common.loadingInfo": "Жүктөлүүдө... Куттуунуузун үүзүнө салуу...",

  // Уммумий функциялар
  "common.moreFeatures": "Көбүрөөк функциялар",
  "common.confirm": "Тутунуу",
  "common.saveing": "Сакталуда... Куттуунуузун үүзүнө салуу...",
  "common.searchPlacholder": "Издөө үчүн аhtar сөз киргизүү",
  "common.iSee": "Мен түшүнөм",
  "common.pageErrorTips1": "Ой, бетте ката болду~",
  "common.pageErrorTips2": "Бетті кайта жүктөңүз же колдоо менен байланышыңыз~",
  "common.refresh": "Кайта жүктөүү",
  "common.backToHome": "Башкы бетке кайтуу",
  "common.checkTips": " Tekшерелүүдө... Куттуунуузун үүзүнө салуу...",
  "common.back": "Кайтуу",
  "common.cancel": "Баткаптоо (өчүрүү)",
  "common.optional": "Белгилүү (зарыл эмес)",
  "common.required": "Зарыл киргизүү үчүн",
  "common.status": "Статус",
  "common.statusNoDelete": "Өчүрүлгөн жок",
  "common.statusDelete": "Өчүрүлгөн",
  "common.submit": "Жөнөтүү",
  "common.disable": "Өчүрүү",
  "common.enable": "Активдүүкө алуу",
  "common.year": "Жыл",
  "common.month": "Ай",
  "common.day": "Күн",
  "common.version": "Версиясы:",
  "common.backHome": "Башкы бетке кайтуу",
  "common.backHomeSorry": "Куттуунуузун үүзүнө салуу, беттинтип жок болду",
  "common.requestTips1": "Мaalымат алынуда, кайта жөнөтпөңүз",
  "common.requestTips2": "Система билдирүүлөрү",
  "common.requestTips3": "Кирүү сессиясын устуну бүттү, кайта кирүңүз",
  "common.requestTips4": "Кайта кирүү",
  "common.requestTips5": "Кирүү дұрыс эмес же сессиясын устуну бүттү, кайта кирүңүз.",
  "common.requestTips6": "Серверде ката болду, кайтында кайталандырыңыз.",
  "common.requestTips7": "Система сұрауынын устуну бүттү",
  "common.requestTips8": "Система интерфейси",
  "common.requestTips9": "Ката",
  "common.iknow": "Мен түшүнөм",
  "common.logoutSuccess": "Чыкүү ийгиликтүү болду",
  
  // Көбүрөөк маалыматтык бөлүм
  "common.knowMore.title": "Көбүрөөк маалымат үчүн, Beineng менен байланышыңыз",
  "common.knowMore.email": "Байланыш үчүн электрондуу пошта",
  "common.knowMore.phone": "Байланыш үчүн телефон номери",
  "common.knowMore.wechat": "Байланыш үчүн WeChat",
  "common.knowMore.website": "Официальдуу веб сайт адресси",
  "common.knowMore.address": "Байланыш үчүн адрес",
  "common.knowMore.addressDetail": "Гуандун провинциясы Дуньгуань шаары Хуанцян җуматасы Хуанюньпу ауылы Циньси 8 чолу 5-бин 1301-номердүү 1205-кумтура",
  
  // Локалдык байланыш
  "common.localConnection": "Локалдык байланыш",
  "common.operateInApp": "Операцияларды аппта аткарыңыз!",
  
  "common.enbleStaus": "Активдүү статус",
  "common.battery.status": "Үндөгдөш жок, чыккөш жок",

  // Аккаунттагы байланышлар
  "account.forgetThePassword": "Парольун унуттуңузму",
  "account.logInDirectly": "Тек кирүү",
  "account.tips1": "Бетке keçүүдө... Куттуунуузун үүзүнө салуу...",
  "account.tips2": "Алдына колдонуу шарттарынынды окуп калыңыз жана раскаптырыңыз!",
  "account.autoLogin": "Автоматтык кирүү",
  "account.userLogin": "Пользователь кирүү",
  "account.registerTips": "Аккаунт жокпmuzбу? Тиркелеңүү үчүн бул жерге басыңыз",
  "account.userEmail": "Пользователь аты / Электрондуу пошта",
  "account.userEmailTips": "Пользователь атыны же электрондуу поштаны киргизүү",
  "account.password": "Пароль",
  "account.passwordTips": "Парольду киргизүү",
  "account.submit": "Жөнөтүү",
  "account.submitTips": "Жөнөтүүдө... Куттуунуузун үүзүнө салуу...",
  "account.otherLoginTips": "Же башка кирүү учрусуну таңдаңыз",
  "account.userRegistration": "Пользователь тиркелеңүү",
  "account.userName": "Пользователь аты",
  "account.userNameTips": "Пользователь атыны киргизүү",
  "account.emailTips1": "Электрондуу пошта адрессини киргизүү",
  "account.emailTips2": "Дұрыс эмес электрондуу пошта формасы",
  "account.phone": "Телефон",
  "account.phoneTips1": "Телефон номерин киргизүү",
  "account.phoneTips2": "Дұрыс эмес телефон номери",
  "account.phoneTips3": "Телефон номерин киргизүү",
  "account.passwordTips1": "Парольду киргизүү (6-30 символ)",
  "account.passwordTips2": "Дұрыс эмес пароль формасы: Пароль Англисче буквалары, сандар, астындагы чиңалуу (_), чиңалуу (-) жана nöqtө (.) бар болушу керек, узундугу 6-12 символ",
  "account.passwordTips3": "Киргизилген эки пароль тыйнык эмес, текшерип кайта киргизүүңүз!",
  "account.passwordTips4": "Парольду киргизүү: Пароль Англисче буквалары, сандар, астындагы чиңалуу (_), чиңалуу (-) жана nöqtө (.) бар болушу керек",
  "account.passwordTips5": "Парольду тутунуу",
  "account.passwordTips6": "Парольду тутунуу үчүн киргизүү",
  "account.passwordTips7": "Киргизилген эки пароль тыйнык эмес, текшерип кайта киргизүүңүз!",
  "account.passwordTips8": "Парольду тутунуу үчүн киргизүү",
  "account.passwordTips9": "Ийгиликтүү болду, тиркелеңүү аяктады!",
  "account.passwordTips10": "Сиздин пользователь атыңыз:",
  "account.emailIs": "Сиздин электрондуу поштаңыз:",
  "account.goToLoginPage": "s секундтан кийин автоматтык түрдө кирүү бетке keçет",
  "account.goLogin": "Кирүү",
  "account.goRegister": "Тиркелеңүү",
  "account.loginSuccess": "Кирүү ийгиликтүү болду",
  "account.email": "Электрондуу пошта",
  "account.sologn": "Сиз үчүн өзгөчө тizenдирилген интегралдык энергия платформасын түзөбүз",
  "account.pleaseAgree": "Мен окуп калып раскаптым",
  "userAgreement.privacyPolicy": "Частность саясаты",

  // Текшерүү кодунун байланышлары
  "account.code": "Текшерүү кодасы",
  "account.codeTips": "Текшерүү кодуну киргизүү",
  "account.codeTips2": "Дұрыс эмес текшерүү кодасы",

    "account.inviteCodeTips": "Чакыруу кодун киргизиңиз",
    "account.inviteCodeHint": "Чакыруу кодун алуу үчүн орнотуучуга же тейлөө кызматкерлерине кайрылыңыз",
  // Пароль өзгөртүү жана калыңдыруу
  "account.modifyPasswordByAccount": "Аккаунт аркылуу пароль өзгөртүү",
  "account.modifyPasswordByEmail": "Электрондуу пошта аркылуу пароль өзгөртүү",
  "account.getPasswordByAccount": "Аккаунт аркылуу пароль алуу",
  "account.getPasswordByEmail": "Электрондуу пошта аркылуу пароль алуу",

  "account.sendEmailTips": "Текшерүү кодасы электрондуу поштага жөнөтүлдү, текшеңиз",
  "account.name": "Аккаунт аты",
  "account.newPassword": "Жаңы пароль",
  "account.confirmNewPassword": "Жаңы парольду тутунуу",
  "account.nameTips": "Аккаунт атыны киргизүү",
  "account.passwordModifySuccess": "Пароль өзгөртүү ийгиликтүү болду",
  "account.emailCode": "Электрондуу пошта текшерүү кодасы",
  "account.emailCodeTips": "Электрондуу пошта текшерүү кодасын киргизүү",
  "account.emailCodeTips2": "Дұрыс эмес электрондуу пошта текшерүү кодасы",
  "account.emailModifySuccess": "Пароль өзгөртүү ийгиликтүү болду",
  "account.passworTips1": "Сиздин парольunuz калыңдырылды!",
  "account.passwordTips11": "Парольду тутунуу үчүн киргизүү",
  "account.passwordTips12": "Жаңы парольду киргизүү",
  "account.nickname": "Кличка",
  "account.modifyNickname": "Кличка өзгөртүү",
  "account.modifyNicknameSuccess": "Кличка өзгөртүү ийгиликтүү болду!",
  "account.nicknameTips": "Кличканы киргизүү",
  "account.nicknameError": "Кличка өзгөртүү ийгиликтүү болмады!",

  // Тез тиркелеңүү жана кирүү
  "account.login": "Кирүү",
  "account.quickRegister": "Тез тиркелеңүү",
  "account.sendCode": "Текшерүү кодасын жөнөтүү",
  "account.sendTips": "s секундтан кийин кайта жөнөтүңө болот",
  "account.sendEmailIng": "Электрондуу пошта жөнөтүлүүдө... Куттуунуузун үүзүнө салуу...",
  "account.emailNotEmpty": "Электрондуу пошта өрісі бос болбошун",
  "account.registerAccount": "Аккаунт тиркелеңүү",
  "account.registerWelcome": "SusprSafe тиркелеңүүгө қош келдіңіз",
  "account.usernameLimit": "Пользователь аты буква менен басталуу керек, тек буквалар, сандар жана астындагы чиңалуу (_) бар болушу керек, узундугу 5-15 символ",

  // Автордуу хукук маалыматтары
  "copyright.desc2": "Веб сайт тиркелеңүү маалыматтары: Гуандун провинциясы ICP тиркелеңүү номери 2021169764",

  // Пользователь маалыматтарын өзгөртүү
  "editUserInfo.editUserInformation": "Пользователь маалыматтарын өзгөртүү",
  "editUserInfo.modifyUsername": "Пользователь атысын өзгөртүү",
  "editUserInfo.changePictures": "Профиль суретін өзгөртүү",
  "editUserInfo.savePicturesSuccess": "Профиль суреті сакталды ийгиликтүү",
  "editUserInfo.saveError": "Сақтоо ийгиликтүү болмады",
  "editUserInfo.pictureLimit": "Суреттин көлөмү 2 МБден көп болбошун",
  "editUserInfo.uploadPicture": "Профиль суретін жүктөүү",
  "editUserInfo.picturePreview": "Алдынбаскы көрүү",
  
  "editUserInfo.bindPhoneNumber": "Телефон номерин биндүү",
  "editUserInfo.bindEmail": "Электрондуу поштаны биндүү",
  "editUserInfo.changePassword": "Пароль өзгөртүү",

  "editUserInfo.notificationSettings": "Бildirүү орналаштуулар",
  "editUserInfo.editAccount": "Аккаунт маалыматтарын өзгөртүү",
  "editUserInfo.waitBingting": "Биндүүдө... Куттуунуузун үүзүнө салуу...",
  "editUserInfo.collapse": "Кызылдау (т бөлүңүү)",
  "editUserInfo.modifyBinding": "Биндүүнүн өзгөртүү",
  
  "editUserInfo.emailAddress": "Электрондуу пошта адресси",
  "editUserInfo.tips1": "Электрондуу пошта биндүү ийгиликтүү болду",
  "editUserInfo.tips2": "Сақтоо ийгиликтүү болмады",
  "editUserInfo.tips3": "Электрондуу пошта текшерүү кодасы жөнөтүлүүдө... Куттуунуузун үүзүнө салуу...",
  "editUserInfo.tips4": "Текшерүү кодасы xxxx электрондуу поштага жөнөтүлдү, текшеңиз",
  "editUserInfo.tips5": "Текшерүү кодасын жөнөтүү ийгиликтүү болмады!",
  "editUserInfo.tips6": "Телефон номерин биндүүлдү",
  "editUserInfo.tips7": "Электрондуу поштаны биндүүлдү",
  "editUserInfo.emailTips1": "Электрондуу пошта адрессини киргизүү",
  "editUserInfo.emailTips2": "Дұрыс эмес электрондуу пошта формасы",
  "editUserInfo.emailTips3": "xxxx секундтан кийин кайта жөнөтүңө болот",
  "editUserInfo.emailTips4": "Текшерүү кодасын жөнөтүү",
  "editUserInfo.emailTips5": "Электрондуу пошта текшерүү кодасының өрісі бос болбошун",
  "editUserInfo.emailTips6": "Дұрыс эмес электрондуу пошта текшерүү кодасы",
  "editUserInfo.emailCode": "Электрондуу пошта текшерүү кодасы",
  "editUserInfo.save": "Сактоо",

  // Телефон биндүүнүн байланышлары
  "editUserInfo.phoneTips1": "Телефон номерин биндүү ийгиликтүү болду",
  "editUserInfo.phoneTips2": "SMS текшерүү кодасы жөнөтүлүүдө... Куттуунуузун үүзүнө салуу...",
  "editUserInfo.phoneTips3": "SMS текшерүү кодасы xxxx номерине жөнөтүлдү, текшеңиз",
  "editUserInfo.phoneTips4": "SMS текшерүү кодасын жөнөтүү ийгиликтүү болмады!",
  "editUserInfo.phoneTips5": "Телефон номерин киргизүү",
  "editUserInfo.phoneTips6": "Дұрыс эмес телефон номери формасы",
  "editUserInfo.phoneTips7": "SMS текшерүү кодасын жөнөтүү",
  "editUserInfo.phoneTips8": "SMS текшерүү кодасы",
  "editUserInfo.phoneTips9": "SMS текшерүү кодасының өрісі бос болбошун",
  "editUserInfo.phoneTips10": "Дұрыс эмес SMS текшерүү кодасы",
  "editUserInfo.phone": "Телефон номери",


  // Bildirүү орналаштуулар
  "editUserInfo.noticeTips1": "Бildirүү орналаштууларын алуу ийгиликтүү болмады!",
  "editUserInfo.noticeTips2": "Бildirүү орналаштууларын сактоо ийгиликтүү болду!",
  "editUserInfo.noticeTips3": "Баттареянын дарылык түскөнүнүн билдирүүсү",
  "editUserInfo.noticeTips4": "Үндөгдөш аяктаңынын билдирүүсү",
  "editUserInfo.errorNotification": "Ката билдирүүсү",
  "editUserInfo.updateNotification": "Жаңарту билдирүүсү",
  "editUserInfo.monthlyStatisticsNotification": "Айлик статистика билдирүүсү",
  "editUserInfo.notificationMethod": "Алдын алуу учрусу",

  // Пользователь атына байланыштуу илтимостуулар
  "editUserInfo.userNameTips1": "Пользователь атысын сактоо ийгиликтүү болду",
  "editUserInfo.userNameTips2": "Пользователь атысын сактоо ийгиликтүү болмады",
  "editUserInfo.userNameTips3": "Пользователь атыны киргизүү",
  "editUserInfo.userNameTips4": "Дұрыс эмес пользователь аты формасы: Тек сандар, астындагы чиңалуу (_) жана Англисче буквалары бар болушу керек",
  "editUserInfo.userNameTips5": "Пользователь атыны киргизүү",
  "editUserInfo.userNameTips6": "Сакталуда... Куттуунуузун үүзүнө салуу...",
  "editUserInfo.userName": "Пользователь аты",

  // Профиль суретін өзгөртүү илтимостуулар
  "editUserInfo.avatorTips": "Профиль суретін өзгөртүү үчүн басыңыз",
  "editUserInfo.verifyCodeTips1": "Алынган текшерүү кодасын киргизүү:",
  "editUserInfo.verifyCodeTips2": "Сиздин аккаунтыңыздын қауіпсіздигинен көңүлдөн, төмөндөгү түймөге басып андас телефон номерине текшерүү кодасын жөнөтүңүз:",
  "editUserInfo.verifyCodeTips3": "Текшерүү кодасын жөнөтүү",
  "editUserInfo.verifyCodeTips4": "Андас телефон номерин текшерүү ийгиликтүү болду, биндүү үчүн жаңы телефон номерин киргизүү",
  "editUserInfo.verifyCodeTips5": "Сиздин аккаунтыңыздын қауіпсіздигинен көңүлдөн, төмөндөгү түймөге басып андас электрондуу поштага текшерүү кодасын жөнөтүңүз:",
  "editUserInfo.verifyCodeTips6": "Андас электрондуу поштаны текшерүү ийгиликтүү болду, жаңы электрондуу поштаны киргизүү",
  "editUserInfo.verifyCodeTips7": "Еski пароль",
  "editUserInfo.verifyCodeTips8": "Алдына, электрондуу поштаны биндүүңүз!",
  "editUserInfo.verifyCodeTips9": "Текшерүү кодасы электрондуу поштага жөнөтүлдү, текшеңиз",
  "editUserInfo.verifyCodeTips10": ", автоматтык түрдө кирүү бетке keçет",

  // Bildirүүнүн байланышлары
  "hems.notice.title": "Бildirүү тақырыбы", 
  "hems.notice.content": "Бildirүү мазмуну", 
  "hems.notice.operate": "Операция",
  "hems.notice.noRead": "Окулмаган",
  "hems.notice.read": "Окулган",
  "hems.notice.warning": "Ескертүү",
  "hems.notice.error": "Ката",
  "hems.notice.success": "Статистика есептелүү",
  "hems.notice.sys": "Система маалыматтары",
  "hems.notice.operateSuccess": "Операция ийгиликтүү болду",
  "hems.notice.operateTips": "Операция үчүн элементти таңдаңыз",

  // Башкы бет
  "hems.home.selfuseRate": "Өзүндө колдонуу үздикти",
  "hems.home.percent": "Үздік",
  "hems.home.todayData": "Бүгүнкү маалыматтар",
  "hems.home.todayPowerGeneration": "Бүгүнкү энергия өндөгдөнү",
  "hems.home.salesIncome": "Энергия сатып берүүнүн кирими",
  "hems.home.saved": "Сиз тазап калдыңыз",
  "hems.home.reduce": "Көрөкөш түзүнүн азайтуу",
  "hems.home.tips1": "Азырда маалымат жок, сиз еще xxxxны биндөөгө болмadyңуз",
  "hems.home.criticalLoad": "Критikal жүзүн",
  "hems.home.keyVoltage": "Критikal төксөз",
  "hems.home.householdLoad": "Үй жүзүн",
  "hems.home.householdVoltage": "Үй төксөзү",
  "hems.home.generalLoad": "Уммумий жүзүн",
  "hems.home.generalVoltage": "Уммумий төксөзү",
  "hems.home.batteryHealth": "Баттарея săğlıгы статусу",
  "hems.home.averageTemp": "Орто температура",
  "hems.home.gridLoad": "Электрик сети жүзүн",
  "hems.home.toggeleDataSource": "Көрсөтүлгөн маалыматтары төмөндөгү сыяктуу өзгөртүлдү:",
  "hems.home.toggleTips": "Озгөрткөңүзбү?",
  "hems.home.modeSending": "Режим командасын жөнөтүүдө... Куттуунуузун үүзүнө салуу...",
  "hems.home.modeSuccess": "Режим өзгөртүү ийгиликтүү жөнөтүлдү!",
  "hems.home.isOnline": "Онлайнмун?",
  "hems.home.useStatus": "Колдонуу статусу",
  "hems.home.workModeText": "Активдүү иш режимы:",
  "hems.home.toggleDataSourceText": "Көрсөтүлгөн маалыматтары төмөндөгү сыяктуу өзгөртүлдү:",
  "hems.ev.charge.status": "Үндөгдөш статусу",
  "hems.ev.charge.time": "Үндөгдөш убактысы",
  "hems.ev.charge.count": "Чындык үндөгдөш саны (убактыа бою)",
  "hems.ev.charge.status.empty": "Бос",
  "hems.ev.charge.status.ing": "Баттареяга bağlı. Үндөгдөш",
  "hems.ev.charge.status.null": "Баттареяга bağlı, бирок үндөгдөш жок",
  "hems.ev.charge.status.error": "Ката",
  "hems.hour": "Саат",
  "hems.minue": "Минут",
  "hems.ev.chagre.number": "Үндөгчү номери",

  // Пользователь гидди
  "hems.userGuide.selfUse": "Өзүндө өндөгдөн энергияны колдонуу",
  "hems.userGuide.selfUseTips": "Алдына күн энергиясын колдонуңуз, егер жеткіліксіз болса, электрик сеть менен толтуруңуз",
  "hems.userGuide.economyMode": "Экономикалык режим",
  "hems.userGuide.economyModeTips": "Электрик баасына негізделген энергия колдонуу стратегиясын оптималдаштыруу",
  "hems.userGuide.emergencyMode": "Төзөк жағдай режимы",
  "hems.userGuide.emergencyModeTips": "Критikal жүзүнө энергия колдоосун касиеттештируу",

  // График бет
  "hems.history.energyStatistics": "Энергия статистикасы",
  "hems.history.revenueStatistics": "Кирими статистикасы",
  "hems.history.greenStatistics": "Жашыл чыкқын азайтуу",
  "hems.history.revenueTitle": "Энергия сатып берүүнүн жалпы кирими",
  "hems.history.savingsTitle": "Жалпы тазалаңдақ",
  "hems.history.carbonTitle": "Жалпы көркөш азайтуу",
  "hems.history.day": "Күн",
  "hems.history.month": "Ай",
  "hems.history.year": "Жыл",
  "hems.history.beforeDay": "Күн бери",
  "hems.history.afterDay": "Күн кийин",
  "hems.history.beforeMonth": "Ай бери",
  "hems.history.afterMonth": "Ай кийин",
  "hems.history.beforeYear": "Жыл бери",
  "hems.history.afterYear": "Жыл кийин",
  "hems.history.totalUse": "Жалпы колдонуу",
  "hems.history.fullScreen": "Толук экран",
  "hems.history.timeSelect": "Күнү таңдаңыз",
  "sync.tips1": "Мaalымат синхронизациясы командасы ийгиликтүү жөнөтүлдү!",
  "sync.tips2": "Мaalымат синхронизациясы жүргүзүлүүдө, көп маалыматтан болгондуктан убактыа керек, 50 минутадан кийин кайта текшеңиз~",
  "sync.tips3": "Көчөмүнүн маалымат синхронизациясы gecikirishi мүмкүн, егер маалыматтарда тегиздештиктер көрсөтүлсө, төмөндөгү түймөге басыңыз:",
  "sync.tips4": "Мaalыматты синхронизациялоо",

  // Үндөгчү маалыматтары
  "charge.info": "Үндөгчү маалыматтары",
  "news.loading": "Жүктөлүүдө...",
  "news.noMore": "Башка маалымат жок",
  "hems.pv.power": "Күн энергиясы көлөмү",

  // UEH өзгөчө функциялар
  "ueh.sellPower": "Сатып берилген энергия көлөмү",
  
  // Меню
  "menu.home": "Башкы бет",
  "menu.history": "Тарих маалыматтары",
  "menu.device": "Көчөмдөр",
  "menu.settings": "Орналаштуулар",
  "menu.messageCenter": "Билдирүү борбору",
  "menu.help": "Колдоо жана көмүк",
  "menu.mine": "Менин (ширин)",


  // Менин орналаштууларым
  "mine.userSetting": "Пользователь орналаштуулар",
  "mine.terminalSetting": "Базалык терминал орналаштуулар",
  "mine.uploadCloud": "Мaalыматты клубкуга жүктөүү",
  "mine.changeVersion": "Жаңартуну текшерүү",
  "mine.language": "Тилди өзгөртүү",
  "mine.about": "Апп туралы",
  "mine.feedback": "Кайырымдылык",
  "mine.logout": "Чыкүү",
  "mine.logoutAccount": "Аккаунтты өчүрүү",

  // Аккаунт өчүрүүнүн байланышлары
  "mine.logoutAccountTips": "Атты [] аккаунтты өчүрүү",
  "mine.logoutAccountTips1": "[] менен биндилген аккаунтты өчүрүү",
  "mine.logoutAccountCare": "Аккаунт өчүрүү сұрауынын ескертүүлөрү:",
  "mine.logoutAccountCare1": "1. Аккаунт қауіпсіз статуста",
  "mine.logoutAccountCare1-1": "Аккаунт орто колдонуу режимында, күрөңүү, шарттарды бұзүү же жабуу қауіпсиздиги жок",
  "mine.logoutAccountCare2": "2. Аккаунт доступу жана биндүү өчүрүлдү",
  "mine.logoutAccountCare2-1": "Учунчы тараптагы платформаларга болгон бардык аккаунт доступлары өчүрүлдү",
  "mine.logoutAccountCare3": "3. Өчүрүлгөнден кийин аккаунтты калыңдыра албайсыз, пользователь маалыматтары өчүрүлдү",
  "mine.logoutAccountCare3-1": "Өчүрүлгөнден кийин биндилген телефон номери, электрондуу пошта жана байланыштуу маалыматтары өчүрүлдү, калыңдыра албайсыз",
  "mine.confirmLogout": "Өчүрүүнү тутунуу",
  "mine.logoutSuccess": "Аккаунт ийгиликтүү өчүрүлдү!",


  // Кайырымдылык проблемалары
  "mine.feedbackIssues": "Проблемалар жана кайырымдылык",
  "mine.feedQuantity": "Көлөмү",
  "mine.feedAmount": "Максимум 9 сурет, бир суреттин максимум көлөмү 1 МБ",

  // Bildirүү орналаштууларын байланышлары
  "mine.notice.fail": "Бildirүү орналаштууларын алуу ийгиликтүү болмады!",
  "mine.notice.saveSuccess": "Бildirүү орналаштууларын сактоо ийгиликтүү болду!",
  "mine.notice.saveFail": "Сақтоо ийгиликтүү болмады!",
  "mine.notice.title": "Бildirүү орналаштуулар",
  "mine.notice.batteryLow": "Баттареянын дарылык түскөнүнүн билдирүүсү",
  "mine.notice.chargingFinish": "Үндөгдөш аяктаңынын билдирүүсү",
  "mine.notice.error": "Ката билдирүүсү",
  "mine.notice.update": "Жаңарту билдирүүсү",
  "mine.notice.monthly": "Айлик статистика билдирүүсү",
  "mine.notice.receiveType": "Алдын алуу учрусу",

  // Тил орналаштуулуна қош келдіңіз
  "mine.language.welcome": "SusprSafeге қош келдіңіз",
  "mine.language.desc1": "Сиздин үйүнүн орналасына негізделген тил версиясын таңдаңыз",
  "mine.language.desc2": "Сиз апп орналаштууларында кез келген убактыда оны өзгөртө аласыз",

  // Ширин маалыматтары
  "mine.userInfo.avatar": "Профиль суреті",
  "mine.userInfo.nickname": "Кличка",
  "mine.userInfo.password": "Пароль",
  "mine.userInfo.changePassword": "Пароль өзгөртүү",
  "mine.userInfo.setPassword": "Пароль орналаштуу",
  "mine.userInfo.phoneNumber": "Телефон номери",
  "mine.userInfo.bindPhone": "Телефонну биндүү",
  "mine.userInfo.bindEmail": "Электрондуу поштаны биндүү",
  "mine.loginExpired": "Кирүү сессиясын устуну бүттү, кайта кирүңүз",
  "mine.userInfo.title": "Пользователь маалыматтары",
  "mine.userInfo.bind": "Биндүү",
  "mine.userInfo.modify": "Өзгөртүү",
  "mine.userInfo.modifyNickname": "Кличка өзгөртүү",
  "mine.userInfo.userNickname": "Пользователь кличкасы",
  "mine.userInfo.selectPic": "Жүктөүү үчүн суретті таңдаңыз",
  "mine.userInfo.saveSuccess": "Сақтоо ийгиликтүү болду",
  "mine.userInfo.uploadFail": "Жүктөүү ийгиликтүү болмады",
  "mine.userInfo.avatarSaveSuccess": "Профиль суреті сакталды ийгиликтүү",
  "mine.userInfo.nameTips1": "Кличка өрісі бос болбошун",
  "mine.userInfo.nameTips2": "Кличканы киргизүү",

  // Уммумий таңдау илтимостуулар
  "common.pleaseSelect": "Таңдаңыз",
  "question.commonQuestions": "Жиі сурулган суроолор",
  "account.toggleLanguage": "Тилди өзгөртүү",
  "account.localConnection": "Локалдык байланыш",
  "account.selectLanguage": "Тилди таңдаңыз",
  "account.sendEmailToast": "Текшерүү кодасы xxx электрондуу поштага жөнөтүлдү, текшеңиз",
  "account.emailError": "Дұрыс эмес электрондуу пошта формасы",
  "account.sendEmailFail": "Жөнөтүү ийгиликтүү болмады, кайта аракеттеңүүңүз",
  
  "common.submitting": "Жөнөтүүдө... Куттуунуузун үүзүнө салуу...",

  "device.page.noData": "Азырда маалымат жок, бул бетти тек аппта көрө аласыз"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};